import React from 'react';
import PropTypes from 'prop-types';

import { PLPHero } from 'components/plp/PLPHero/PLPHero';
import { JumpNav } from 'components/plp/JumpNav/JumpNav';
import StickyBar from 'components/plp/StickyBar/StickyBar';

import { compose, lifecycle, withHandlers, withState } from 'recompose';

import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import './PSPLayout.scss';

export const quickLinks = [
	{ id: 'search-storage', label: 'Search Storage' },
	{ id: 'how-it-works', label: 'How It Works' },
	{ id: 'reviews-section', label: 'Reviews' },
	{ id: 'why-ssdc', label: 'Why Us' },
];

export const enhance = compose(
	withState('activeLink', 'setActiveLink', null),
	withHandlers({
		// Method used in both jump navs, manages active state/url
		// scrolls on click
		handleLinkClick:
			({ setActiveLink }) =>
			(linkId) =>
			(e) => {
				e && e.preventDefault && e.preventDefault();
				setActiveLink(linkId);

				scrollToElement(`#${linkId}`, {
					offset: -window.innerHeight / 6,
					behavior: 'smooth',
				});

				// Update the URL hash while preserving query params
				// This lets us sync jump navs/manage history etc
				const { pathname, search } = window.location;
				const newUrl = `${pathname}${search}#${linkId}`;
				window.history.pushState(null, '', newUrl);
			},
	}),

	// Lifecycle for hash sync. Handles scroll to section/manages state
	// for both jumpNavs
	lifecycle({
		// On url change/updates active link
		componentDidMount() {
			const { setActiveLink } = this.props;
			const hash = window.location.hash.replace('#', '');

			if (quickLinks.some((link) => link.id == hash)) {
				setActiveLink(hash);
			}
		},
	}),
);

const PSPLayout = ({
	activeLink,
	handleLinkClick,
	storageType,
	handleSearch,
}) => {
	return (
		<div className={`psp-layout ${storageType}`}>
			<StickyBar
				activeLink={activeLink}
				handleLinkClick={handleLinkClick}
				handleSearch={handleSearch}
			/>
			<div
				className="psp-content"
				id="search-storage"
			>
				<PLPHero
					storageType={storageType}
					handleSearch={handleSearch}
				/>
				<JumpNav
					activeLink={activeLink}
					handleLinkClick={handleLinkClick}
				/>
			</div>
		</div>
	);
};

PSPLayout.propTypes = {
	storageType: PropTypes.string.isRequired,
	activeLink: PropTypes.string,
	handleLinkClick: PropTypes.func.isRequired,
	handleSearch: PropTypes.func,
};

export default enhance(PSPLayout);
